function Car() {
  return <h2>Hi, I am a Car!</h2>;
}

export default Car;
